/**
 * Lightweight conversion tracking via Plausible custom events.
 * Safe no-op when Plausible isn't loaded (i.e. on preview/dev — see the
 * production-host guard in public/index.html), so calls are always safe.
 *
 * Configure matching goals in the Plausible dashboard (Goals → Custom event)
 * using the same event names, e.g. "Discovery Enquiry", "Brochure Download".
 */
export function trackEvent(name, props) {
  try {
    if (typeof window !== "undefined" && typeof window.plausible === "function") {
      window.plausible(name, props ? { props } : undefined);
    }
  } catch (_) {
    /* never let analytics break a user flow */
  }
}

// Named conversion events used across the public site.
export const EVENTS = {
  DISCOVERY_ENQUIRY: "Discovery Enquiry",
  BROCHURE_DOWNLOAD: "Brochure Download",
  TRIAL_REQUEST: "Trial Request",
  ASSESSMENT_START: "Assessment Start",
};
